import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import SLETDetails from './section-components/slet-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const SLET = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>SLET Coaching In Chennai | Exams for Assistant professors/Lectures</title>
            <meta name="description" content="Getting a faculty position in an educational institute is the aspiration of a great many people. The top SLET coaching in Chennai helps aspirants who are looking to make it big in their teaching career." />
        </Helmet>
        <PageHeader headertitle="SLET"  />
        <SLETDetails />
        <Footer />
    </div>
}

export default SLET